export const NEW_SLIDE_MARKETPLACE_FLAG = 'AHA-42884-new-slide-market-place'

export const NEW_SLIDE_MARKETPLACE_VARIANTS = {
  TREATMENT: 'Treatment',
  CONTROL_1: 'Control1',
  CONTROL_2: 'Control2',
}

// Release flag (boolean) gating the new data-driven slide picker (US 1).
// Kept here alongside the other slide-picker experiment constants.
export const DATA_DRIVEN_SLIDE_PICKER_FLAG = 'release-data-driven-slide-picker'
